import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type7TimeTable } from "./type7Time.table";

@Component({
  selector: "spec-app-type7-time-list-window",
  templateUrl: "./type7Time.list.html",
  styleUrls: ["./type7Time.list.scss"]
})
export class Type7TimeListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type7TimeTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type7TimePage",
      this.tab.system,
      (object) => `Type7Time at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type7TimeList reload");
    super.reload();
    this.table.refreshList();
  }
}
